module.exports = __webpack_public_path__ + "static/media/excel.8cdcf933.svg";